import React from 'react';
import { IonText } from '@ionic/react';
import styled from 'styled-components';

const StyledPageTitle = styled(IonText)`
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 1.3;
  margin: 32px 16px;
  color: ${(props: { theme?: { token?: { colorTextSecondary?: string } } }) =>
    props.theme?.token?.colorTextSecondary};
  display: block;
`;

interface PageTitleProps {
  children: React.ReactNode;
}

export const PageTitle: React.FC<PageTitleProps> = ({ children }) => {
  return <StyledPageTitle>{children}</StyledPageTitle>;
};
